export enum PDFSectionIds {
    BALANCE = 'SECTION_BS',
    INCOME = 'SECTION_IS',
    CASHFLOW = 'SECTION_CFS',
    NOTES = 'SECTION_NOTES',
    AOP = 'SECTION_AOP',
    EMS = 'SECTION_EMS',
    FAS = 'SECTION_FAS',
    COMPLEMENTARY_REPORT = 'SECTION_CR',
    APBS = 'SECTION_APBS',
    APIS = 'SECTION_APIS',
    FCP = 'SECTION_FCP',
    APPENDIX = 'SECTION_APPENDIX',
}
